import script from "./CarResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./CarResult.vue?vue&type=script&setup=true&lang=ts"

import "./CarResult.vue?vue&type=style&index=0&id=2bf7ba1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bf7ba1c"]])

export default __exports__